module.exports = __webpack_public_path__ + "static/vityazPrivatbank-350e4b4f6b6c9fe04a8cc9e7575ce604.png";